import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { documentPropType } from "custom-prop-types";
import styles from "components/grid/cell-formatters/select-cell-formatter.scss";

export const SelectCellFormatter = ({
  documents,
  id,
  isSelected,
  isShiftPressed,
  onRowsDeselected,
  onRowsSelected,
  selectedDocumentIds
}) => {
  if (isSelected) {
    return (
      <div className={ `${styles.checkbox} ${styles.selected}` } onClick={ () => onRowsDeselected(id) } />
    );
  }
  return (
    <div
      className={ styles.checkbox }
      onClick={ () => multiSelectOrNot(documents, id, isShiftPressed, onRowsSelected, selectedDocumentIds) }
    />
  );
};

SelectCellFormatter.defaultProps = {
  documents: [],
  id: null,
  isShiftPressed: false,
  selectedDocumentIds: []
};

SelectCellFormatter.propTypes = {
  documents: PropTypes.arrayOf(documentPropType),
  id: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  isSelected: PropTypes.bool.isRequired,
  isShiftPressed: PropTypes.bool,
  onRowsDeselected: PropTypes.func.isRequired,
  onRowsSelected: PropTypes.func.isRequired,
  selectedDocumentIds: PropTypes.arrayOf(PropTypes.string)
};

const multiSelectOrNot = (documents, id, isShiftPressed, onRowsSelected, selectedDocumentIds) => {
  if (selectedDocumentIds.length > 0 && isShiftPressed) {
    const currentIndex = R.findIndex(R.propEq("id", id))(documents);
    const lastIndex = R.findIndex(R.propEq("id", selectedDocumentIds[selectedDocumentIds.length - 1]))(documents);
    const first = currentIndex > lastIndex ? lastIndex : currentIndex;
    const second = currentIndex > lastIndex ? currentIndex : lastIndex;
    const multiSelectArray = R.slice(first, second + 1, documents);
    return multiSelectArray.forEach((document) => onRowsSelected(document.id));
  }
  return onRowsSelected(id);
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/select-cell-formatter.jsx